<template>
<!-- Header 
    ============================================= -->
    <header id="home">
      <!-- Start Navigation -->
      <nav class="navbar navbar-default navbar-fixed dark no-background bootsnav">
        
        <!-- Start Header Navigation -->
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle"
            data-toggle="collapse"
            data-target="#navbar-menu"
          >
            <i class="fa fa-bars"></i>
          </button>
          <a class="navbar-brand" href="index.html">
            <img src="assets/img/logo.png" class="logo" alt="Logo" />
          </a>
        </div>
        <!-- End Header Navigation -->

        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse" id="navbar-menu">
          <ul
            class="nav navbar-nav navbar-right"
            data-in="fadeInDown"
            data-out="fadeOutUp"
            style="margin-right: 0;"
          >
            <li class="dropdown">
                <!--<a href="index.html">Home</a>-->
                <router-link to="/">Inicio</router-link>
              <!--<li><a href="index.html">Home Version One</a></li>
                               
                                <li><a href="">H <span class="badge">New</span></a></li>
                                <li><a href="">H <span class="badge">New</span></a></li>-->
            </li>

            <li class="dropdown">
                <!--<a href="contactos.html">Contáctanos</a>-->
                <router-link to="/contactanos">Contáctanos</router-link>
            </li>

                        
                <!--<li class="dropdown">
                    <a class="dropdown-toggle" data-toggle="dropdown" >Nuestra empresa</a>
                    <ul class="dropdown-menu">

                        <li><a href="index.html#nosotros">Nosotros</a></li>
                        <li><a href="contactos.html">Contáctanos</a></li>
                        <li><a href="">Trabaja con nosotros</a></li>
                        
                    </ul>
                </li>-->
                <li class="dropdown">
                    <router-link to="/indicadores">Indicadores Previsionales</router-link>
                </li>                        
                <!--<li class="dropdown">
                    <a class="dropdown-toggle" data-toggle="dropdown" >Servicios</a>
                    <ul class="dropdown-menu">
                        <li><a href="#">Vapp</a></li>
                        <li><a href="#">Analisis y Centralicacion de Datos</a></li>
                        <li><a href="#">RPA para Contadores y Pymes</a></li>
                        <li><a href="#">Asesoria en tecnologías</a></li>
                        <li><a href="#">Seguridad de datos</a></li>
                    </ul>
                </li>
                <li class="dropdown">
                    <a class="dropdown-toggle" data-toggle="dropdown" >Proyectos</a>
                    <ul class="dropdown-menu">

                        <li><a href="#">Nube privada</a></li>
                        <li><a href="#">Automatización para Contadores y Pymes</a></li>
                        <li><a href="#">Seguridad informática</a></li>
                        <li><a href="#">Ejecución de Proyectos IT</a></li>
                        <li><a href="#">Implementación de software</a></li>
                        
                    </ul>
                </li>-->
                <li class="dropdown">
                    <a class="dropdown-toggle" data-toggle="dropdown" >Recursos</a>
                    <ul class="dropdown-menu">
                        <!--<li><router-link to="/#indicadores">Indicadores</router-link></li>-->
                        <!--<li><a href="#noticias">Noticias</a></li>-->
                        <li><a href="/#indicadores">Indicadores</a></li>
                        <li><a href="/#tutoriales">Tutoriales</a></li>
                        <li><a :href="cons.links.soporte.anydeskDownload">Descargar AnyDesk</a></li>
                        <li><a target="_blank" href="source/ManualesVapp/Soluciones VAPP.html">Manual de Uso Vapp</a></li>
                    </ul>
                </li>
                <li class="dropdown">
                    <a class="dropdown-toggle" data-toggle="dropdown" >Soporte</a>
                    <ul class="dropdown-menu">
                    <li><a target="_blank" :href="cons.links.soporte.zohoTickets">Crear Ticket</a></li>
                    </ul>
                </li>
                <li class="dropdown">
                    <a class="dropdown-toggle" data-toggle="dropdown" >EDIG</a>
                    <ul class="dropdown-menu">
                    <!--<li><a href="edig">Cliente Nuevo</a></li>-->
                    <li><router-link to="/edig">Cliente Nuevo</router-link></li>
                    <li><a :href="cons.links.soporte.zendeskEdig">¿Tienes un problema?</a></li>
                    </ul>
                </li>
                <VappModulo />
            </ul>
        </div>
        <!-- /.navbar-collapse -->

      </nav>
      <!-- End Navigation -->
    </header>
    <!-- End Header -->

</template>


<script>
    import VappModulo from './VappModulo.vue';
    import cons from '@/utils/const';
    export default {
        name: "Header",
        components: { VappModulo },
        data() {
            return { cons };
        },
        beforeMount() {},
    };
</script>